var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHighlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons System"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0247 6.80202L4.41294 13.4148C4.14128 13.7061 3.99331 14.0915 4.00023 14.4898C4.00715 14.888 4.16842 15.268 4.45004 15.5497C4.73166 15.8314 5.11164 15.9928 5.50989 15.9998C5.90815 16.0068 6.29357 15.8589 6.58493 15.5873L13.1982 8.97552L11.0247 6.80202ZM11.7797 8.97552L10.4825 10.2727L9.73006 9.51776L11.0272 8.22059L11.7797 8.97552ZM5.87565 14.879C5.77425 14.9757 5.63953 15.0296 5.49944 15.0296C5.35935 15.0296 5.22463 14.9757 5.12323 14.879C5.02362 14.7792 4.96768 14.6439 4.96768 14.5028C4.96768 14.3618 5.02362 14.2265 5.12323 14.1266L9.02027 10.2291L9.7752 10.984L5.87565 14.879ZM14.6624 11.3376L16.0002 12.0068L14.6624 12.6779L13.9938 14.0132L13.3251 12.6779L11.9873 12.0068L13.3251 11.3376L13.9938 10.0003L14.6624 11.3376ZM7.30575 6.67511L5.96795 6.00646L7.30575 5.33781L7.97441 4L8.64306 5.33781L9.98087 6.00646L8.64306 6.67511L7.97441 8.01292L7.30575 6.67511ZM13.6592 6.34104L12.4889 5.75565L13.6592 5.17027L14.2446 4L14.83 5.17027L16.0002 5.75565L14.83 6.34104L14.2446 7.5113L13.6592 6.34104Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight);
export default __webpack_public_path__ + "static/media/highlight.18be271d41981977f2e88a346056f337.svg";
export { ForwardRef as ReactComponent };